import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { CustomerListHolderCompanyNameCell } from './customer-list-holder-company-name.cell';
import { CustomerListHolderCompanyNameHeader } from './customer-list-holder-company-name.header';

export const CustomerListHolderCompanyNameColumn: IdentifiedColumnDef<
  GatewayCustomerModel,
  NonNullable<GatewayCustomerModel['holder']>['companyName'] | undefined
> = {
  id: 'holderCompanyName',
  enableSorting: false,
  header: CustomerListHolderCompanyNameHeader,
  cell: CustomerListHolderCompanyNameCell,
};
